import FormField from "../base/FormField";

export default class GridItem extends FormField {

    render() {
        var className = `grid-item-text ${this.props.className ? this.props.className : ""} ${this.props.textAlign ? 'text-' + this.props.textAlign : ""}`;
        var render = <div className={className}>{this.props.value}</div>;
        return this.getRenderGridItem(render);
    }
}